/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

export class SitterProfileServiceChanged extends AnalyticsEvent {
  eventName = 'sitter-profile-service-changed';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: {
    serviceSlug: string;
    providerId: string;
    pageVariant?: 'revamp';
  }) {
    super(eventProperties);
  }
}

export class SitterProfileServiceSelectorOpened extends AnalyticsEvent {
  eventName = 'sitter-profile-service-selector-opened';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { providerId: string }) {
    super(eventProperties);
  }
}

export class SitterProfileSeeAllRatesClicked extends AnalyticsEvent {
  eventName = 'sitter-profile-see-all-rates-clicked';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { serviceSlug: string; pageVariant?: 'revamp' }) {
    super(eventProperties);
  }
}

export class SitterProfileEditProfilePressed extends AnalyticsEvent {
  eventName = 'sitter-profile-edit-profile-pressed';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { pageVariant?: 'revamp' }) {
    super(eventProperties);
  }
}

export class SitterProfileCancellationPolicyClicked extends AnalyticsEvent {
  eventName = 'owner-conversion-member-profile-cancellation-policy';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.provider_profile;

  constructor(eventProperties: { providerId: string; pageVariant?: 'revamp' | 'legacy' }) {
    super(eventProperties);
  }
}
